// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"177":"home","328":"admin","571":"settings","821":"inspection"}[chunkId] || chunkId) + "." + {"177":"1583f714","328":"ec8fa5ba","408":"a911bb35","571":"aaf6ed70","821":"45b48bde"}[chunkId] + ".css";
};